module.exports = "https://web-assets-production.autolist.com/_next/static/images/austin-tx-88d558a7bc13b664385677043e5e1305.jpg";